import { useCallback, useMemo, useState } from 'react';
import { useBootstrapper } from '@/ui-kit/contexts/BootstrapperContext';

type State = 'idle' | 'ready' | 'loading';

type Value = {
  state: State;
  generate: () => Promise<void>;
};

export const useGetPdf = () => {
  const { bootstrapper } = useBootstrapper();
  const [state, setState] = useState<State>('idle');

  const downloadPdf = useCallback(async () => {
    const link = await bootstrapper?.createLink();
    if (!link) {
      return;
    }

    await bootstrapper?.downloadPdf(link);
  }, [bootstrapper]);

  const generate = useCallback(async () => {
    if (!bootstrapper) {
      return;
    }

    setState('loading');
    try {
      await downloadPdf();
      setState('ready');

      setTimeout(() => {
        setState('idle');
      }, 2000);
    } catch (error) {
      console.error('Failed to download PDF:', error);
      setState('idle');
    }
  }, [bootstrapper, downloadPdf]);

  return useMemo<Value>(
    () => ({
      state,
      generate,
    }),
    [state, generate],
  );
};
